import { createSlice } from '@reduxjs/toolkit';

interface IState {
    eventTitle: string;
    id: number;
}

const initialState: IState = {
    eventTitle: '',
    id: 0
};

export const eventFormSlice = createSlice({
    name: 'eventForm',
    initialState,
    reducers: {
        setTitle(state, action) {
            state.eventTitle = action.payload;
        },
        removeTitle(state) {
            state.eventTitle = '';
        }
    }
});

export const { setTitle } = eventFormSlice.actions;

export default eventFormSlice.reducer;
